<div markdown src="assets/md/legal/privacy/privacy_{{version()}}.md"></div>
